import { useMemo, useRef, useState } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import Mapping from './Mapping';
import Workflow from './Workflow';
import ActionableAlert from './ActionableAlert';
import ShareLinkFolder from './ShareLinkFolder';
import AEDViewSetting from './AEDViewSetting';

const useStyle = makeStyles(() => ({
  root: {
    borderRadius: '0 0.937rem 0.937rem',
    backgroundColor: '#ffffff',
    padding: '1.875rem 1.875rem 0',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  tabBox: {
    display: 'flex',
    paddingBottom: '1.5rem',
    borderBottom: 'solid 0.063rem #d9d9d9',
    width: '100%',
  },
  tabSelected: {
    borderRadius: '20px',
    // width: '17rem',
    // height: '2.5rem',
    padding: '0.56rem 0.94rem',
    backgroundColor: '#538fff',
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    color: '#ffffff',
  },
  tabUnSelected: {
    borderRadius: '20px',
    // width: '17rem',
    // height: '2.5rem',
    padding: '0.56rem 0.94rem',
    backgroundColor: '#f5faff',
    fontSize: '1rem',
    color: '#c0c6cb',
    border: 'solid 1px #c0c6cb',
  },
  bodyRoot: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    gap: '1.1rem',
  },
  toolbar: {
    position: 'absolute',
    left: '-3.438rem',
  },
}));

const Admission = () => {
  const classes = useStyle();
  const [tabValue, setTabValue] = useState(1);
  const rootRef = useRef();
  const mappingRef = useRef();

  const tabList = useMemo(
    () => [
      {
        value: 1,
        testID: 'TAB-WORKFLOW',
        title: 'Emergency Admission Workflow',
      },
      {
        value: 2,
        testID: 'TAB-MAPPING',
        title: 'Specialty & Ward Mapping',
      },
      {
        value: 3,
        testID: 'TAB-ALERT',
        title: 'Actionable Alert',
      },
      {
        value: 4,
        testID: 'TAB-SHARE-FOLDER-LINK',
        title: 'Share Folder Link',
      },
      {
        value: 5,
        testID: 'TAB-AED_VIEW',
        title: 'AED View',
      },
    ],
    []
  );

  const scrollHandler = () => {
    if (rootRef) {
      const { scrollTop, clientHeight, scrollHeight } = rootRef.current;

      if (scrollTop + clientHeight + 1 >= scrollHeight) {
        mappingRef?.current?.turnPage();
      }
    }
  };

  return (
    <div className={classes.root} ref={rootRef} onScroll={scrollHandler}>
      <div className={classes.bodyRoot}>
        <Box display="flex" gridGap="1.25rem" className={classes.tabBox}>
          {tabList.map((item) => (
            <ButtonBase
              id={item.testID}
              key={item.testID}
              className={item.value === tabValue ? classes.tabSelected : classes.tabUnSelected}
              onClick={() => setTabValue(item.value)}
            >
              {item.title}
            </ButtonBase>
          ))}
        </Box>
        {tabValue === 1 && <Workflow />}
        {tabValue === 2 && <Mapping mappingRef={mappingRef} />}
        {tabValue === 3 && <ActionableAlert />}
        {tabValue === 4 && <ShareLinkFolder />}
        {tabValue === 5 && <AEDViewSetting />}
      </div>
    </div>
  );
};

export default Admission;
